import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsMenu',
  setup(__props) {

const route = useRoute();
const router = useRouter();

function showEvents() {
  router.push('/events');
}
function showSources() {
  router.push('/events/sources');
}

function getPage(path: string): string {
  switch (path) {
    case '/events':
      return 'List';
    case '/events/sources':
      return 'Sources';
  }
  return '';
}

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { app: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_breadcrumbs, {
        items: ['Events', getPage(_unref(route).path)]
      }, null, 8, ["items"]),
      (_unref(route).path !== '/events/sources')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            flat: "",
            color: "info",
            onClick: showSources
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Sources")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(route).path !== '/events')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            flat: "",
            color: "info",
            onClick: showEvents
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("List")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})